<template>
  <div class="attention">
  <div class="attention__title">Внимание!</div>
  <p>Плашка «реклама» будет отражена в верхнем левом углу креатива (формироваться будет внутри Buzzoola). Поэтому в креативах клиента необходимо предусмотреть отсутствие важных элементов в креативе в Marked Zone с учётом&nbsp;её&nbsp;размеров:&nbsp;<strong>&nbsp;ширина:&nbsp;74px,&nbsp;высота:&nbsp;22px</strong></p>
  <p>На сами креативы ничего наносить дополнительно не нужно.</p>
</div>
</template>

<script>
export default {
  name: 'markedZoneAtention',
};
</script>

<style scoped lang='stylus'>
@import '../../styles/main.styl'
@import '../../styles/documentation_article_markup.styl'

</style>
